/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import {
  ChooseLocationFormType,
  ChooseLocationSchema,
} from "../../services/location/location.schema";
import React, { FC, useEffect, useState } from "react";

import { Button } from "@mui/material";
import ChooseHospitalCard from "./ChooseHospitalCard";
import { GvRadioGroupController } from "../Controllers";
import { ILocationDirection } from "../../services/location/location.interface";
import Loading from "../Loading/Loading";
import { MAX_LOCATION_RANGE_IN_MILES } from "../../config/params";
// import { NotificationSaveContainer } from
// "../../pages/ChooseLocation/containers";
import { locationCardsStyle } from "../LayoutOnboarding/LayoutOnboarding.style";
import { useForm } from "react-hook-form";
import { useUserCreateStore } from "../../hooks/redux-hooks/user-create-store/user-create.store";
import { useUserDetail } from "../../services/user-detail/user-detail.service";
import { yupResolver } from "@hookform/resolvers/yup";
import { CentralLoadingIndicator } from "..";

interface ChooseLocationFormProps {
  onSubmit: (data: any) => void;
  setMapData: (location : any) => void;
  setShowMap: React.Dispatch<React.SetStateAction<boolean>>
  setMarkers: React.Dispatch<React.SetStateAction<any[]>>
  markerClick?: any,
  modalViaBubble?: boolean,
  location?: any,
  setIsBubble?: (value: boolean)=>void,
  setValueInForm? (value: any): void;
  control?:any;
  directions?: any;
  setMsa?: (data: string) => void
  getCurrentLocationId?: (data: string) => void
  handleSetLocationSubmit?: () => void
  handleViewMoreLocationsCta: () => void
  isCtaDisabled:boolean;
  loading?: boolean;
}

const ChooseLocationListView: FC<ChooseLocationFormProps> = ({ setMsa, onSubmit, setMapData, setShowMap, setMarkers,
  markerClick, modalViaBubble, location, getCurrentLocationId, control, directions, loading = false, isCtaDisabled, handleSetLocationSubmit, handleViewMoreLocationsCta }) => {
  // eslint-disable-next-line no-unused-vars
  const [placeId, setPlaceId] = useState<string>("");
  // eslint-disable-next-line no-unused-vars
  const [addressSelected, setAddressSelected] = useState<string>("");
  const { setLocation } = useUserCreateStore();
  const [listDirections, setListDirections] = useState<any[]>([]);
  // eslint-disable-next-line no-unused-vars
  const { user } = useUserDetail();
  const {
    handleSubmit, setValue } = useForm<ChooseLocationFormType>({
      mode: "onChange",
      resolver: yupResolver(ChooseLocationSchema),
      defaultValues: {
        location: "",
      },
    });


  const handleSetLocationMap = (location: ILocationDirection) => {
    setMsa && setMsa(location.cityName);
    setLocation(location.idLocation);
    onSubmit({ location: location.locationName, address: location.locationAddress, locationId: location.idLocation });
    setMapData({ lat: location.position.lat, lng: location.position.lng });
  };

  useEffect(()=>{
    if (location) {
      handleSetLocationMap(location);
    }
  }, [modalViaBubble]);

  useEffect(() => {
    if (markerClick) {
      setValue("location", markerClick.idLocation);
    }
  }, [markerClick]);

  useEffect(() => {
    if (directions.length) {
      setShowMap(false);
      setValue("location", "");
    }
  }, [directions]);

  const currentLocationId = getCurrentLocationId && getCurrentLocationId("location");

  useEffect(() => {
    if (directions.length) {
      setListDirections(
        directions
          .map((direction: ILocationDirection) => ({
            lat: direction?.position?.lat,
            lng: direction?.position?.lng,
            value: direction.idLocation,
            label: <div
              className=""
              onClick={() => handleSetLocationMap(direction)}
            >
              <ChooseHospitalCard
                currentLocationId={currentLocationId!}
                direction={direction}
                handleSetLocationSubmit={handleSetLocationSubmit}
              />
            </div>,
          })),
      );
    }
  }, [currentLocationId, directions]);

  useEffect(() => {
    if (listDirections?.length && directions) {
      setMarkers(directions);
      setMapData({ lat: directions?.[0]?.position?.lat, lng: directions?.[0]?.position?.lng });
      setShowMap(true);
    }
  }, [listDirections]);

  useEffect(() => {
    if (user) {
      setPlaceId(user?.placeId || "");
      setAddressSelected(user?.address || "");
    }
  }, [user]);

  return <>

    <form onSubmit={handleSubmit(onSubmit)} className="">
      <>

        {listDirections?.length > 0 && (
          <div className="">
            <GvRadioGroupController
              defaultChecked={false}
              control={control}
              name="location"
              label=""
              options={listDirections}
              sx={locationCardsStyle}
            />
          </div>
        )}

        {!isCtaDisabled && (directions?.length > 0) && (
          <div className="text-center">
            {loading ?
              <CentralLoadingIndicator />:
              <Button
                id="viewAllLocationButton"
                variant="text"
                onClick={handleViewMoreLocationsCta}
                sx={{
                  textTransform: "none",
                }}
              >
                View More Locations
              </Button>}

          </div>
        )}
      </>
    </form>
  </>;
};

export default ChooseLocationListView;
